__turbopack_context__.v({
  "card": "XFOeGq_card",
  "container": "XFOeGq_container",
  "desktopButton": "XFOeGq_desktopButton",
  "downloadButton": "XFOeGq_downloadButton",
  "grid": "XFOeGq_grid",
  "image": "XFOeGq_image",
  "leftColumn": "XFOeGq_leftColumn",
  "mobileButton": "XFOeGq_mobileButton",
  "overlay": "XFOeGq_overlay",
  "subtitle": "XFOeGq_subtitle",
  "textWrapper": "XFOeGq_textWrapper",
  "wrapper": "XFOeGq_wrapper",
});
